import { render, staticRenderFns } from "./MarqueeText.vue?vue&type=template&id=26a201c9&scoped=true"
import script from "./MarqueeText.vue?vue&type=script&lang=js"
export * from "./MarqueeText.vue?vue&type=script&lang=js"
import style0 from "./MarqueeText.vue?vue&type=style&index=0&id=26a201c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a201c9",
  null
  
)

export default component.exports